import React, { ReactNode } from 'react';
import styled from 'styled-components';
import {
  boxShadow, primaryFont, primaryHeadingColor, wMedium, maxWidth, retina, maxTablet, maxMobile,
  wLight,
  secondaryFont,
  wMBold,
} from 'Utils/utilsStyle';

const Wrapper = styled.div`
  padding: 25px;
  box-shadow: ${boxShadow};
  background:#fff;
  border-radius: 16px;
  width: 100%;
  height: 100%;
  position: relative;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    border-radius: 12px;
     padding: 16px;
  }
  .title-section{
    color: #424B50;
    font-family: ${secondaryFont};
    font-size: 26px;
    font-weight: ${wMBold};
    line-height: 36px;
    letter-spacing: -0.65px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 16px;
      line-height: 18px;
    }
    @media all and (max-width: ${maxTablet}) {
      font-size: 13px;
    }
  }
  .person-item-widget {
    .image-wrap-placeholder {
      transform: translate(-51%,-52%);
      width: 82% !important;
      height: 82% !important;
      min-width: 82% !important;
      .person-image-holder {
        height: 93% !important;
        width: 93% !important;
      }
    }
    span.text-truncate {
      margin-top: -8px;
    }
  }
 
  .holo-svg {
    height: 100%;
  }
  .horizontal-tips {
    margin: 20px 10px !important;
    min-width: 30%;
    width: 30%;
    @media all and (max-width: ${maxTablet}) {
      width: 29%;
      min-width: 29%;
    }
    @media all and (max-width: ${maxMobile}) {
      margin: 20px 0 !important;
    }
    .text-truncate-two-line {
      color: #000;
      font-family: ${primaryFont};
      font-size: 16px;
      font-weight: ${wLight};
      line-height: 18px;
      letter-spacing: -0.375px;
     -webkit-line-clamp: 3;
     -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      word-wrap: break-word;
    }
    .anticon-check-circle {
      margin-top: 5px;
      @media all and (max-width: ${maxMobile}) {
        margin-top: 2px;
      }
    }
  }
`;

type Props = {
  children: ReactNode,
  title: string
};

const CareerWidgetOverlay = function CareerWidgetOverlay(props: Props) {
  const { children, title } = props;
  return (
    <Wrapper className="widget-row-one">
      <div className="skill-badges">
        <h6 className="title-section text-truncate-one-line">{title}</h6>
        {children}
      </div>
    </Wrapper>
  );
};

export default CareerWidgetOverlay;
